import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-activity-feed-empty",
  templateUrl: "./activity-feed-empty.component.html",
  styleUrls: ["./activity-feed-empty.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ActivityFeedEmptyComponent {}
